import { LogLevel, Configuration } from 'msal';



const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_PROD',
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://prodlinqx.b2clogin.com/prodlinqx.onmicrosoft.com/B2C_1_PROD',
        },
    },
    authorityDomain: 'preprodlinqx.b2clogin.com',
};
export const msalConfig: Configuration = {
  auth: {
    // clientId: "64bad283-55ca-4bce-836e-e2e023f56129", // Local
    clientId: "743ec681-efa8-436d-8dd0-e09570da7861",
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    // redirectUri: "http://localhost:4200/pages/dashboard", //Local
    redirectUri: "https://fracpro.ai/pages/dashboard",
    // postLogoutRedirectUri: "http://localhost:4200/pages/user/logout", //Local
    postLogoutRedirectUri: "https://fracpro.ai/pages/user/logout",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};
export const loginRequest = {
    scopes: []
}

export const silentRequest = {
    scopes: [],
    loginHint: "example@domain.net"
};